// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__ZbpCr","contactHeader":"Contact_contactHeader__d9EPO","contactText":"Contact_contactText__07Zcu","contactInfo":"Contact_contactInfo__MXz-k"};